module.exports = __webpack_public_path__ + "img/illus.a75e0857.png";